// extracted by mini-css-extract-plugin
export default {"Paper":"UnionEducation_Paper__BVMND","Alert":"UnionEducation_Alert__7Ta73","Button":"UnionEducation_Button__7ymqD"};